<template>
  <div>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>
    
    <!-- modal edit-->
    <b-modal
      ref="modal-update"
      id="modal-slug"
      centered
      hide-footer
      :title="`permission: ${formData.name}`">
      <b-form @submit.prevent="updateForm">
        <b-row>
          <b-col md="12">
            <b-form-group>
                <b-form-input
                  v-model="formData.name"
                  placeholder="name"/>
            </b-form-group>
            <b-button
              variant="primary"
              type="submit" >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm 
        }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item   
                @click="formData = props.row"
                v-b-modal.modal-slug      
                v-ripple.400="'rgba(255, 255, 255, 0.15)'">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton, VBModal, BForm, BRow, BCol
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { mapActions  } from 'vuex'

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    VBModal,
    BForm,
    BRow,
    BCol
    },
    props: {
        roleData: Object,
    },
      directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      formData: {},
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'name',
          field: 'name',
        },
        {
          label: 'slug',
          field: 'slug',
        },
        {
          label: 'action',
          field: 'action',
        }
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.rows = this.roleData.permissions
  },
  methods: {
    ...mapActions('role', ['updatePermission']),

    async updateForm() {
      let response = await this.updatePermission({ roleId: this.roleData._id, request: {
        name: this.formData.name,
        slug: this.formData.slug
      }})
      if(response){
        this.rows = response.permissions
        this.$refs['modal-update'].hide()
        this.formData = {}
        this.$swal({
          title: 'Update Permission',
          text: response.message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
  },
}
</script>